"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const InstallationProfile_1 = require("../enums/InstallationProfile");
const GetTariffsProduct_1 = tslib_1.__importDefault(require("./GetTariffsProduct"));
class GetTariffsElectricityProduct extends GetTariffsProduct_1.default {
    constructor() {
        super(...arguments);
        this.consumptionOffPeak = 0;
        this.consumptionReturnPeak = 0;
        this.consumptionReturnOffPeak = 0;
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 2000,
        description: 'The expected yearly electricity consumption in kWh',
    }),
    tslib_1.__metadata("design:type", Number)
], GetTariffsElectricityProduct.prototype, "consumptionPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 900,
        description: 'The expected yearly electricity consumption in kWh in the "off" hours',
    }),
    tslib_1.__metadata("design:type", Number)
], GetTariffsElectricityProduct.prototype, "consumptionOffPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 200,
        description: 'The expected amount of kWh that is returned on the net during the day',
    }),
    tslib_1.__metadata("design:type", Number)
], GetTariffsElectricityProduct.prototype, "consumptionReturnPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 10,
        description: 'The expected amount of kWh that is returned on the net in the "off" hours',
    }),
    tslib_1.__metadata("design:type", Number)
], GetTariffsElectricityProduct.prototype, "consumptionReturnOffPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(InstallationProfile_1.ElectricityInstallationProfile)),
    (0, base_models_1.Docs)({
        example: InstallationProfile_1.ElectricityInstallationProfile.E1A,
        description: `The profile of the electricity meter/installation.
      heavily influences the supply rates.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsElectricityProduct.prototype, "installationProfile", void 0);
exports.default = GetTariffsElectricityProduct;
